import useConfig from "../../../hooks/useConfig";
import { Switch } from "../../../v2/components/ui/switch";

/**
 * Classic View / Enhanced View, the control that decides whether the Audience
 * Layer sits beside the player or over it.
 *
 * v1 FILE IMPORTING A v2 COMPONENT, which is the allowed direction: the
 * boundary test bans v2 from reaching into `@/Pages`, `@/Common` and MUI, and
 * says nothing about v1 using v2. This page is where the two meet, so it is
 * where a shadcn control can be introduced without a wholesale rewrite.
 *
 * It used to be MUI's Switch under about seventy lines of `sx` overrides that
 * existed to make it not look like MUI. The Radix one underneath the v2 Switch
 * is unstyled to begin with, so the same look takes no overrides at all.
 *
 * STYLED INLINE for the reason the v2 Switch itself gives: this renders on the
 * Watch page, which is v1 and therefore inside Bootstrap's global cascade,
 * where a Tailwind utility for a width or a padding quietly resolves to
 * something else.
 */
const CustomChangeButton = ({
  checked,
  setChecked,
}: {
  checked: boolean;
  setChecked: (next: boolean) => void;
}) => {
  const configData = useConfig();
  const active = configData?.primary || "#0b4ea2";

  const label = (text: string, on: boolean) => (
    <span
      style={{
        color: on ? active : "#000",
        fontWeight: 600,
        fontSize: 15,
        lineHeight: 1.2,
        whiteSpace: "nowrap",
      }}
    >
      {text}
    </span>
  );

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "5px 10px",
      }}
    >
      {label("Classic View", !checked)}
      <Switch
        checked={checked}
        onCheckedChange={setChecked}
        // Named for what it switches to, not for what it is: a switch called
        // "view" tells a screen reader nothing about which view it lands on.
        aria-label="Enhanced View"
      />
      {label("Enhanced View", checked)}
    </div>
  );
};

export default CustomChangeButton;
